<template>
  <step-section
    :title="$t('material')"
    :description="$t('materialStepDescription')"
    :loading="loading$"
    :step-number="getStepNumber('material')"
  >
    <div class="row row--custom">
      <div
        class="col-12 col-xs-6 col-md-6--custom col-item-3 col-margin"
        v-for="material in materials"
        :key="material.id"
      >
        <material-block
          v-bind="material"
          :checked="isItemChecked('material.id', material.id)"
          @click="() => handleItemClick(material)"
        />
      </div>
    </div>
  </step-section>
</template>

<script>
  import MaterialBlock from '@/components/blocks/MaterialBlock.vue';
  import stepMixin from './stepMixin';

  export default {
    name: 'MaterialStep',
    mixins: [stepMixin],
    props: {
      materials: Array,
    },
    methods: {
      handleItemClick(material) {
        this.updateFormField({
          field: 'material',
          value: {
            id: material.id,
            name: material.name,
          },
        });
      },
    },
    components: {
      MaterialBlock,
    },
  };
</script>
